<script setup>
import { computed } from 'vue'

const props = defineProps({
    small: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: 'border',
    },
    variant: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        default: 'Loading...',
    },
})

const classes = computed(() => [
    `spinner-${props.type}`,
    props.small ? `spinner-${props.type}-sm` : '',
    props.variant ? `text-${props.variant}` : '',
])
</script>

<template>
    <div :class="classes" role="status" :style="{'color': constants.spinnerColor}">
        <span class="sr-only">{{ label }}</span>
    </div>
</template>
